import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'

const Header = () => {
  return (
    <Grid justify="space-between" align="center">
      <Col>
        <Grid direction="row" gutter={20} align="center">
          <Col gutter={20}>
            <Image src="/pdfs/axon/axon-logo.svg" maxWidth={100} ignoreFixedSize />
          </Col>
          <Col gutter={20}>
            <Text>Axon Enterprise, Inc.</Text>
            <Text>17800 N 85th St</Text>
            <Text>Scottsdale, Arizona 85255</Text>
            <Text>United States</Text>
            <Text>VAT: 86-0741227</Text>
            <Text>Domestic:(800) 978-2737</Text>
            <Text>International: +1.800.978.2737</Text>
          </Col>
        </Grid>
      </Col>
      <Col>
        <Grid direction="column" gutter={5} align="end">
          <Col gutter={5}>
            <Text bold align="right">
              Q-740905-45889TM
            </Text>
          </Col>
          <Col style={{ backgroundColor: '#000' }} width="100%" gutter={5}>
            <Text color="#fff" align="right">
              Issued: 08/20/2025
            </Text>
          </Col>
          <Col style={{ backgroundColor: '#ffe599' }} width="100%" gutter={5}>
            <Grid direction="row" align="end">
              <Col>
                <Text align="right">🡆</Text>
              </Col>
              <Col flex={1}>
                <Text align="right">Quote Expiration:</Text>
              </Col>
            </Grid>
          </Col>
          <Col style={{ backgroundColor: '#000' }} width="100%" gutter={5}>
            <Text align="right" color="#fff">
              Estimated Contract Start Date: 08/18/2025
            </Text>
          </Col>
          <Col>
            <Text align="right">Account Number: 607550</Text>
          </Col>
          <Col>
            <Text align="right">Payment Terms: N30</Text>
          </Col>
          <Col>
            <Text align="right">Mode of Delivery: GENFF-AirD</Text>
          </Col>
          <Col>
            <Text align="right">Credit/Debit Amount: $0.00</Text>
          </Col>
        </Grid>
      </Col>
    </Grid>
  )
}

export default Header
